import moment from 'moment';

export const days_open = (date) => {
  const today = moment(new Date()).format("DD/MM/YYYY");
  const request_date = moment(date).format("DD/MM/YYYY");
  const diff = moment(today, "DD/MM/YYYY").diff(moment(request_date, "DD/MM/YYYY"));
  const duration = moment.duration(diff);
  return duration._data.days;
};